module.exports = __webpack_public_path__ + "img/image-thumb-7.de1efd62.webp";